import { Component, Input, Output, OnDestroy, OnInit, EventEmitter } from '@angular/core';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { forkJoin, lastValueFrom, Observable, Subscription } from 'rxjs';
import { Card } from 'src/app/core/models/card/card.model';
import { Controller } from 'src/app/core/models/controller.model';
import { Permission } from 'src/app/core/models/permissions/permission.model';
import { User } from 'src/app/core/models/user/user.model';
import { ProjectService } from 'src/app/modules/project/services/project.service';
import { ApiRolesService } from 'src/app/modules/roles/services/http/api-roles.service';
import { RolesService } from 'src/app/modules/roles/services/roles.service';
import { ApiUsersService } from 'src/app/modules/users/services/http/api-users.service';
import { UsersService } from 'src/app/modules/users/services/users.service';
import { LocationGroup } from '../../services/api-location-groups.service';
import { EditCardModalComponent } from '../../../modules/rooms/components/edit-card-modal/edit-card-modal.component';
import { CardsService } from 'src/app/modules/users/services/cards.service';
import { enterAnimation } from 'src/app/shared/animations/animations';
import { LocationGroupsService } from '../../services/location-groups.service';
import { ApiProjectService, KeyOption } from 'src/app/modules/project/services/http/api-project.service';
import { CurrentUserStoreService } from 'src/app/core/services/current-user-store.service';
import { FiltersService } from '../../services/filters.service';
import { ProjectObject } from 'src/app/core/models/hvac-modes/project-object.model';
import { PermissionType } from 'src/app/core/models/permissions/permission.enum';
import { CustomTranslatePipe } from '../../pipes/custom-translate.pipe';
import { Location } from 'src/app/core/models/project/location.model';
import { BleKeyQrCodeComponent } from '../ble-key-qr-code/ble-key-qr-code.component';
import { DemoModeService } from '../../services/demo-mode.service';
import { CardStatus } from 'src/app/core/models/card/card-status.model';
import { CardReaderService } from 'src/app/core/services/card-reader.service';
import { DEMO_MODE, HIDE_GENERATE_QR_CODE_FOR_CARD } from 'src/environments/environment';
import { CardType } from 'src/app/core/models/card/card-type.model';
import { PaginationData } from 'src/app/core/models/pagination-data.model';
import { SoftwarePermissionCode } from 'src/app/core/models/permissions/permission-code';

@Component({
  selector: 'app-room-modal-cards',
  templateUrl: './room-modal-cards.component.html',
  animations: [enterAnimation],
  styleUrls: ['./room-modal-cards.component.scss'],
})
export class RoomModalCardsComponent implements OnInit, OnDestroy/* , AfterViewInit  */ {
  @Input() location: Location;
  @Output() guestCardsUpdated: EventEmitter<Card[]> = new EventEmitter<[]>();

  selectedControllers: Controller[] = []; // only one controller should be selected at a time [0]
  guestCards: Card[] = [];
  allStaffCards: Card[] = [];
  roomSwap = false;
  openModal = false;
  openModalDuplicate = false;
  controllers: Controller[];

  permissions: Permission[];
  permissionsSubscription: Subscription;

  accessControlIds: string[] = [];
  floorList$: Observable<LocationGroup[]> = this.locationGroupsService.getFloorList();

  targetRoomToMoveCard: Location;
  movingGuest: User;
  guestAddedSubscription: Subscription;

  openCardOnReaderBackupModal = false;
  activePopup: string;
  userToShowInPopup: User;
  tablesReady = false;
  guestFreeSpace: number;
  cardMaxNumberReached = false;

  signedInUser: User;
  User= User;
  swPermissions = SoftwarePermissionCode;

  objectsFilterFull$ = this.filtersService.getObjectsFilterFull();
  selectedDesignation = '*/*/*/*';
  allObjects$: Observable<ProjectObject[]> = this.projectService.getObjects();

  guestLocationsThin$: Observable<Location[]> = this.apiProjectService.getAllGuestRoomLocations('slim');

  loading = false;
  backupCardUid ='';

  lastGuestCardOnHolderHighlighted$ = this.cardsService.getLastGuestCardOnHolderHighlighted()
  mainController: Controller;
  cardSyncActiveSubscription: Subscription;
  cardSyncActive = false;
  userBeingCreated = false;
  modalLoading = false;
  multipleRooms: Location[] = [];
  accessControlListForLocationId: KeyOption[];
  locations: Location[] = this.projectService.getGuestRoomLocations();
  cardToCopy: Card;

  errorReadingCard = '';

  HIDE_GENERATE_QR_CODE_FOR_CARD = HIDE_GENERATE_QR_CODE_FOR_CARD;

  paginationData: PaginationData = new PaginationData();
  pageSize = 10;

  staffCardSearchValue = '';

  constructor(private modalController: ModalController,
              private apiUsersService: ApiUsersService,
              private usersService: UsersService,
              private projectService: ProjectService,
              private locationGroupsService: LocationGroupsService,
              private rolesService: RolesService,
              private apiRolesService: ApiRolesService,
              private cardsService: CardsService,
              private currentUserStoreService: CurrentUserStoreService,
              private apiProjectService: ApiProjectService,
              private filtersService: FiltersService,
              private alertController: AlertController,
              private pipe: CustomTranslatePipe,
              private toastController: ToastController,
              private demoModeService: DemoModeService,
              private cardReaderService: CardReaderService,
              ) {}

  ngOnInit(): void {
    this.controllers = this.location.controllers.$values
    this.mainController = Controller.getMainController(this.controllers)
    this.selectController(this.controllers[0])
    this.getPermissions();
    this.getIsCardSyncActive();
    this.guestAddedSubscription = this.usersService.newGuestAdded.subscribe( () => {
      this.getCardsByLocation();
    })
    this.signedInUser = Object.assign(new User(), this.currentUserStoreService.getUser());

    this.apiUsersService.getBackupCardForLocation(this.location.locationId).subscribe( (backupCard: Card) => {
      if (backupCard) {
        this.backupCardUid = backupCard.uid;
      } else {
        this.backupCardUid = '';
      }
    });
    this.apiProjectService.getKeyOptionsAccessControllListForLocationId(this.mainController.locationId).subscribe(keyOptions => {
      this.accessControlListForLocationId = keyOptions;
    });
  }

  getIsCardSyncActive(){
    this.cardSyncActiveSubscription = this.projectService.cardSyncActive$.subscribe(value => {
      this.cardSyncActive = value;
    });
  }

  selectController(controller: Controller) {
    this.selectedControllers[0] = controller;
    this.selectedControllers = this.selectedControllers.slice();
    // this.mainController = controller;
    this.getCardsByLocation();
  }

  getPermissions() {
    this.permissions = this.rolesService.getPermissions();
    this.apiRolesService.getPermissions().subscribe();
    this.permissionsSubscription = this.rolesService.permissionsChanged.subscribe(() => {
      this.permissions = this.rolesService.getPermissions();
    });
  }

  onRoomSelection(room: Location) {
    this.apiUsersService.getCardsByLocationAndType(room.locationId, 1).subscribe((gCards: Card[]) => {
      const guestCardsOfSelectedRoom = gCards.filter(card => !card.isBackup);
      const freeSpaces =  Controller.getMaxGuestCardsNumber(room.controllers.$values[0]) - 1;
      if (room.locationId !== this.location.locationId && guestCardsOfSelectedRoom.length < freeSpaces) {
        this.openModal = true;
        this.targetRoomToMoveCard = room;
      }else{
        this.writeToastMsg('No available space for cards in that room!');
      }
    });
  }

  async writeToastMsg(msg: string) {
    const toast = await this.toastController.create({
      message: this.pipe.transform(msg),
      duration: 4000,
      // color: 'primary'
    });
    await toast.present();
  }

  async writeToastMsgWithConfirmation(pin: string) {
    const toast = await this.toastController.create({
        message: `${this.pipe.transform('New card created with PIN')}: ${pin}`,
        position:'middle',
        buttons: [
          {
            text: 'Ok',
            role: 'cancel',
          }
        ]
      });
      await toast.present();
  }

  getCurrentTime(): Date {
    return new Date();
  }

  getCardsByLocation(stopLoading = false) {
    this.tablesReady = false;
    if (DEMO_MODE) {
      this.demoModeService.getData().subscribe (value => {
        this.guestCards = value.GuestCardsByLocation.filter( card => !card.isBackup);
        this.guestCards.sort((a, b) => {
          const dateA = a.validFrom instanceof Date ? a.validFrom.getTime() : new Date(a.validFrom).getTime();
          const dateB = b.validFrom instanceof Date ? b.validFrom.getTime() : new Date(b.validFrom).getTime();
          return dateA - dateB;
        }); // SORTING BY VALID FROM
        this.guestCardsUpdated.next(this.guestCards);
        this.guestFreeSpace = (Controller.getMaxGuestCardsNumber(this.mainController) - 1) - this.guestCards.length;
        // if we already have max number of guest cards we need to say that if someone is trying to create a new one
        if (Controller.isGuestRoom(this.location.controllers.$values[0]) &&
         this.guestCards.length >= Controller.getMaxGuestCardsNumber(this.location.controllers.$values[0]) - 1) {
          this.cardMaxNumberReached = true;
        } else {
          this.cardMaxNumberReached = false;
        }
        this.tablesReady = true;
        if (stopLoading) {
          this.loading = false;
        }
      })
    }
    const cardTypes = this.cardsService.getCardTypes();

    this.apiUsersService.getCardsByLocationAndType(+this.location.locationId, 0).subscribe( (allCards: Card[]) => {
      const guestCards = [];
      const staffCards = [];

      allCards.forEach((card)=> {
        const cardType: CardType = cardTypes.find((ct: CardType)=> {
          return card.type === ct.typeId
        })
        if (CardType.isGuestCard(cardType)) {
          guestCards.push(card)
        } else if (CardType.isStaffCard(cardType)) {
          staffCards.push(card)
        }
      })

      this.guestCards = guestCards.filter( card => !card.isBackup);
      this.guestCards.sort((a, b) => {
        const dateA = a.validFrom instanceof Date ? a.validFrom.getTime() : new Date(a.validFrom).getTime();
        const dateB = b.validFrom instanceof Date ? b.validFrom.getTime() : new Date(b.validFrom).getTime();
        return dateA - dateB;
      }); // SORTING BY VALID FROM
      this.guestCardsUpdated.next(this.guestCards);
      this.guestFreeSpace = (Controller.getMaxGuestCardsNumber(this.mainController) - 1) - this.guestCards.length;
      // if we already have max number of guest cards we need to say that if someone is trying to create a new one
      if (Controller.isGuestRoom(this.location.controllers.$values[0])
        && this.guestCards.length >= Controller.getMaxGuestCardsNumber(this.location.controllers.$values[0]) - 1) {
        this.cardMaxNumberReached = true;
      } else {
        this.cardMaxNumberReached = false;
      }

      this.allStaffCards = staffCards;
      this.allStaffCards.sort((a, b) => {
        const dateA = a.validFrom instanceof Date ? a.validFrom.getTime() : new Date(a.validFrom).getTime();
        const dateB = b.validFrom instanceof Date ? b.validFrom.getTime() : new Date(b.validFrom).getTime();
        return dateA - dateB;
      }); // SORTING BY VALID FROM

      this.tablesReady = true;
      if (stopLoading) {
        this.loading = false;
      }
    })
  }

  async onClickCreateBackupCard() {
    this.openCardOnReaderBackupModal = true;

        let cardReaderInfo: {primaryCardOnReaderInfo?:CardStatus,secondaryCardOnReaderInfo?:CardStatus, error?: string};
        do {
          cardReaderInfo = await this.cardReaderService.getCardInfoFromCardReader()
        if (cardReaderInfo.error) {
          this.errorReadingCard = cardReaderInfo.error;
          await new Promise(resolve => setTimeout(resolve,  this.cardReaderService.pauseBetweenCardReadAttemps));
        } else {
          break;
        }
        } while (cardReaderInfo.error && this.openCardOnReaderBackupModal)

        if (!cardReaderInfo.primaryCardOnReaderInfo) {
          return;
        }

        this.modalLoading = true;
        this.errorReadingCard = '';

          const card = Card.setCardUidsAndTechTypes(new Card(), cardReaderInfo, this.cardReaderService.getDualCardSettings());
          card.type = 1;

          card.validFrom = new Date();
          card.blacklisted = 0;
          if (this.backupCardUid !== '') {// backup card exists
            this.apiUsersService.updateBackupCardForLocation(card, this.location.locationId).subscribe(()=> {
              this.backupCardUid = card.uid;
              this.openCardOnReaderBackupModal = false;
              this.modalLoading = false;
            });
          } else {
            this.apiUsersService.createBackupCardForLocation(card, this.location.locationId).subscribe(()=> {
              this.backupCardUid = card.uid;
              this.openCardOnReaderBackupModal = false;
              this.modalLoading = false;
            });
          }
  }

  getCardPosition(card: Card) {
    const smallerStr = card.customData.substring(card.customData.indexOf('['),card.customData.indexOf(']'));
    const value = smallerStr.substring(smallerStr.indexOf(':')+1, smallerStr.indexOf(','))

    if (value) {
      return value;
    } else {
      // return this.getBackupPosition()+1;
    }
  }

  moveGuestToAnotherRoom(card: Card) {
    this.roomSwap = true;
    this.movingGuest = card.user;
  }

  async deleteCard(card: Card) {
    const alert = await this.alertController.create({
      header: this.pipe.transform('Confirm delete'),
      message: this.pipe.transform('Delete card?'),
      buttons: [ {
        text: this.pipe.transform('Cancel'),
        role: 'cancel',
      },
        {
          text: this.pipe.transform('Delete'),
          handler: () => {
              this.loading = true;
              this.apiUsersService.deleteUserCard(card).subscribe({
                next:() => {
                  this.getCardsByLocation(true);
                },
                error: ()=> {
                  this.loading = false;
                }
            });
          }
        }
      ],
    });
    await alert.present();

  }

  syncGuest(uid: string) {
    this.loading = true;
    this.apiUsersService.syncCard(uid).subscribe({
      next:()=> {
      this.loading = false;
    },
    error: ()=> {
      this.loading = false;
    }
    }
  );
  }

  onChangeObjectSubobject(event) {
    // this.selectedAccessDesignation = event.target.value;
    this.selectedDesignation = event.target.value;
  }

  onCardOnreaderBackupModalDecision(decision) {
    this.errorReadingCard = '';
    this.openCardOnReaderBackupModal = false;
    this.modalLoading = false;
 }

  async onModalDecision(decision) {
    if (decision) { // move card and user
      await this.moveCardAndUserToAnotherRoom()
    } else { // click cancel
      this.targetRoomToMoveCard = this.location;
    }
    this.openModal = false;
    this.roomSwap = !this.roomSwap;
  }

  onDuplicateModalDecision(decision) {
    this.errorReadingCard = '';
    this.openModalDuplicate = false;
    this.modalLoading = false;
  }

  async moveCardAndUserToAnotherRoom() {
    forkJoin([ this.apiProjectService.getKeyOptionsAccessControllListForLocationId(this.targetRoomToMoveCard.locationId),
    this.apiUsersService.getUser(this.movingGuest.userId),
    this.apiProjectService.getAllAccessControlLocations('slim')
    ])
    .subscribe( ([kOs, userToMoveFull, allAccessControllLocations]) => {
      const allAccessControlDesignations = allAccessControllLocations.map((location: Location)=> {return location.locationId})
      const roomsInUserToMove: string[] = userToMoveFull.permissions.reduce((roomsList, perm)=> {
        const permLocationDesignation = perm.locationId
        if ( !allAccessControlDesignations.includes(permLocationDesignation) &&
        perm.typeId === PermissionType.Unlock && permLocationDesignation !== this.location.locationId) {
          roomsList.push(permLocationDesignation.toString())
        }
        return roomsList
      }, [])

      const possibleAccessControllsOnCard: string[] = kOs.reduce((acList, kO)=> {
        const targetPerm = userToMoveFull.permissions.find( (perm:Permission) => perm.locationId == kO.location.locationId)
        if (targetPerm) {
          acList.push(kO.location.locationId.toString())
        }
        return acList;
      }, [])
      this.movingGuest.permissions = [];
      this.permissions.forEach( perm => {
        const locationId = perm.locationId
        if((locationId  && perm.typeId === PermissionType.Unlock) &&
         (this.targetRoomToMoveCard.locationId === locationId
          || possibleAccessControllsOnCard.includes(locationId.toString())
         || roomsInUserToMove.includes(locationId.toString())
         )) {
          this.movingGuest.permissions.push(perm);
        }
      })
      this.loading = true;
      this.apiUsersService.getUser(this.movingGuest.userId).subscribe( user => {
        this.movingGuest.cards = user.cards;
        this.apiUsersService.updateUser(this.movingGuest).subscribe( () => {
          this.getCardsByLocation(true);
        });
      })
    });
  }

  showAccess(event: Event, card: Card) {
    if (event.type === 'mouseenter') {
      this.activePopup = card.uid;
      if (!this.userToShowInPopup) {
        forkJoin([
          this.apiUsersService.getUser(card.userId),
          this.apiProjectService.getKeyOptionsAccessControllListForLocationId(this.location.locationId)
          ]).subscribe(([user, keyOptions])=> {
            this.userToShowInPopup = user;
            this.userToShowInPopup.permissions = user.permissions.filter( (perm: Permission) => {
              // this is returning only access controls
              // const locId = perm.locationId;
              // return keyOptions.some((keyOption: KeyOption)=> {
              //   return keyOption.location.locationId === locId;
              // });

              // this returns rooms too
              return perm.locationId !== this.location.locationId;
            });
          });
      }
    } else if (event.type === 'mouseleave') {
      this.activePopup = undefined;
      this.userToShowInPopup = undefined;
    }
  }

  showAccessPopup(uid: string) {
    if (this.activePopup === uid) {
      return true;
    }
  }

  async editCard(userId: number) {
    const modal = await this.modalController.create({
      component: EditCardModalComponent,
      cssClass: 'cards-popover',
      backdropDismiss: true,
      showBackdrop: true,
      componentProps:  {
        location: this.location,
        userId: userId
        }
    });
    return await modal.present();
  }


  syncAllRoomCards() {
    this.loading = true;
    this.apiUsersService.syncGuestCardsByLocation(this.location.locationId).subscribe({next:()=> {
      this.loading = false;
    },
    error: (error)=> {
      this.loading = false;
      }
    }
    )
  }

  async generateQrCode(card: Card) {
    const modal = await this.modalController.create({
      component: BleKeyQrCodeComponent,
      cssClass: 'qr-code-modal',
      backdropDismiss: true,
      showBackdrop: true,
      componentProps:  {
        card,
        location: this.location
      }
    });
    return await modal.present();
  }

  async onClickCopyCard(cardToCopy: Card) {
    this.cardToCopy = cardToCopy;
    let card: Card = new Card();
    this.openModalDuplicate = true;
    this.accessControlListForLocationId.forEach((kO)=> {
      kO.checked = false;
    })
    this.apiUsersService.getUser(this.cardToCopy.user.userId).subscribe( async (u:User) => {
      u.permissions.forEach((perm: Permission) => {
        const locationId = perm.locationId
        if((locationId && perm.typeId === 1) && !(this.mainController.locationId === locationId)) {
          // check if perm is access control
          const keyOption = this.accessControlListForLocationId.find((kOption)=> {
            return kOption.location.locationId === locationId;
          });
          if (keyOption) {
            keyOption.checked = true;
            return;
          }
          // check if perm is guest room perm
          const guestRoomCont = this.locations.find((location: Location)=> {
            return location.locationId === locationId;
          })
          if (guestRoomCont /* && !this.roomsToJoin.includes(locationId.toString()) */ && this.mainController.locationId !== locationId) {
            this.multipleRooms.push(guestRoomCont);
          }
        }
      });
      if (!this.cardToCopy.isPinEntry) {
        let cardReaderInfo: {primaryCardOnReaderInfo?:CardStatus,secondaryCardOnReaderInfo?:CardStatus, error?: string};
      do {
        cardReaderInfo = await this.cardReaderService.getCardInfoFromCardReader()
      if (cardReaderInfo.error) {
        this.errorReadingCard = cardReaderInfo.error;
        await new Promise(resolve => setTimeout(resolve,  this.cardReaderService.pauseBetweenCardReadAttemps));
      } else {
        break;
      }
      } while (cardReaderInfo.error && this.openModalDuplicate)
      if (!cardReaderInfo.primaryCardOnReaderInfo) {
        return;
      }
      this.modalLoading = true;
      this.errorReadingCard = '';
      card = Card.setCardUidsAndTechTypes(card, cardReaderInfo, this.cardReaderService.getDualCardSettings());
    } else { // use random pin instead of uid
      try {
        const newCardPin:string = await lastValueFrom( this.apiUsersService.generatePinForCard(this.location.locationId))
        card = Card.setPinCardUidsAndTechTypes(new Card(),newCardPin, this.cardReaderService.getDualCardSettings());
      } catch (err) {
        console.log(err,'Pin generation failed' )
        this.openModalDuplicate = false;
        return;
      }
    }

            const multipleRoomsIds = [];
            const accessControlIds = [];
            this.multipleRooms.forEach( loc => {
              multipleRoomsIds.push(loc.locationId.toString());
            });
            this.accessControlListForLocationId.forEach((keyOption: KeyOption) => {
              if (keyOption.checked) {
                accessControlIds.push(keyOption.location.locationId.toString());
              }
            })
            const user: User = new User();
            user.typeId = 3;
            if (this.cardToCopy.user.fullName === undefined || this.cardToCopy.user.fullName === '') {
              user.firstName = 'Guest'
              user.lastName = '';
              user.lastName = Card.getRandomIdForGuestLastName();
            } else {
              const nameSplit = this.cardToCopy.user.fullName.split(' ')
              user.firstName = nameSplit[0]
              user.lastName = nameSplit[1]
              if (user.lastName === undefined || user.lastName === '') {
                user.lastName = Card.getRandomIdForGuestLastName();
              }
            }
            user.email = this.cardToCopy.user.email;
            user.permissions = [];
            this.permissions.forEach( perm => {
              if(perm.locationId && (perm.typeId === 1) && (this.location.locationId === perm.locationId ||
                multipleRoomsIds.includes(perm.locationId.toString()) || accessControlIds.includes(perm.locationId.toString()))) {
                user.permissions.push(perm);
              }
            });
            user.cards = [];
            card.type = 1;
            if (this.isAccessControll(this.mainController)) {
              user.firstName = 'AC'
              user.lastName = Card.getRandomIdForGuestLastName();
            }


            card.userId = 0;
            card.validFrom = this.cardToCopy.validFrom;
            card.validTo = this.cardToCopy.validTo;
            card.blacklisted = 0;
            user.cards.push(card);
            // this.modalController.dismiss();
            if (!this.userBeingCreated) {
              this.userBeingCreated = true;
              this.loading = true;
              this.modalLoading = true;
              // this.openModalDuplicate = true;
              this.apiUsersService.addUser(user).subscribe({
                next:(createdUser) => {
                  this.userBeingCreated = false;
                  this.modalLoading = false;
                  this.openModalDuplicate = false;
                  this.loading = false;
                  this.errorReadingCard = '';
                  if (this.cardToCopy.isPinEntry) {
                    this.writeToastMsgWithConfirmation(card.uid);
                  }
                  // this.cardHasBeenRead = false;
                  this.usersService.guestAdded();
                },
                error: ()=> {
                  this.loading = false;
                  this.modalLoading = false;
                }
              }
              );
            }
        })
  }

  isAccessControll(controller: Controller) {
    return Controller.isAccessControl(controller);
  }

  ngOnDestroy() {
    if (this.permissionsSubscription) {
      this.permissionsSubscription.unsubscribe();
    }
    if (this.guestAddedSubscription) {
      this.guestAddedSubscription.unsubscribe();
    }

    if (this.cardSyncActiveSubscription) {
      this.cardSyncActiveSubscription.unsubscribe();
    }
    this.cardsService.setLastGuestCardOnHolderHighlighted(undefined);
  }

}
